import { Page } from "../page";

import './painting.scss';

export class Painting extends Page {


	constructor() {
		super();

		this.pageTitle = 'PAITING';
		this.pageSetup();
	}


	pageSetup() {
		super.pageSetup();

		if ( this.debug ) {
			console.log( this.pageTitle + ' >>>> page setup');
		}


		this.pageReady();
	}



	pageReady() {
		if ( this.debug ) {
			console.log( this.pageTitle + ' >>>> page ready');
		}

		super.pageReady();
	}

	loaderHidden() {
		super.loaderHidden();

		if ( document.querySelector('.flaws-carousel') ) {
			import('../../components/flaws-carousel/flaws-carousel').then( c => new c.FlawsCarousel( document.querySelector('.flaws-carousel')) );
		}
	}

}

